import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import RandomVerse from './RandomVerse';
import 'bootstrap/dist/css/bootstrap.min.css';


const root = createRoot(document.getElementById('root'));

root.render(
    <RandomVerse />
);